const UNDO = "undo";
const REDO = "redo";
const COPY = "copy";
const CUT = "cut";
const PASTE_ELEMENT = "pasteElement";

const DELETE_CANVAS = "deleteCanvas";
const DUPLICATE_CANVAS = "duplicateCanvas";
const RENAME_CANVAS = "renameCanvas";
const LAYOUT_MOBILE_CANVAS = "layoutMobile";
const SELECT_CANVAS = "selectCanvas";
const SELECT_SITE_CANVAS = "selectSiteCanvas";

const DELETE_ELEMENT = "deleteElement";
const DUPLICATE_ELEMENT = "duplicateElement";
const RENAME_ELEMENT = "renameElement";
const TOGGLE_LOCK_ELEMENT = "toggleLockElement";

const ADD_TEXT_ELEMENT_TITLE = "addTextElementTitle";
const ADD_TEXT_ELEMENT_HEADING = "addTextElementHeading";
const ADD_TEXT_ELEMENT_SUBHEADING = "addTextElementSubheading";
const ADD_TEXT_ELEMENT_PARAGRAPH = "addTextElementParagraph";
const ADD_ELEMENT_SIMPLE = "addElementSimple";
const ADD_ELEMENT_OVAL = "addElementOval";
const ADD_ELEMENT_LINE = "addElementLine";
const ADD_ELEMENT_GRAPHIC = "addElementGraphic";
const ADD_ELEMENT_ICON = "addElementIcon";
const ADD_ELEMENT_IFRAME = "addElementIframe";
const ADD_ELEMENT_VIDEO = "addElementVideo";
const ADD_ELEMENT_GALLERY = "addElementGallery";
const ADD_ELEMENT_SOCIAL_GRID = "addElementSocialGrid";
const ADD_ELEMENT_LOTTIE = "addElementLottie";
const ADD_ELEMENT_BUTTON = "addElementButton";
const ADD_FORM_SUBMIT_BUTTON = "addFormSubmitButton";
const ADD_FORM_FIELD_TEXT = "addFormFieldText";
const ADD_FORM_FIELD_EMAIL = "addFormFieldEmail";
const ADD_FORM_FIELD_PHONE = "addFormFieldPhone";
const ADD_FORM_FIELD_DATE = "addFormFieldDate";
const ADD_FORM_FIELD_MULTI_LINE_TEXT = "addFormFieldMultiLineText";
const ADD_FORM_FIELD_DROPDOWN = "addFormFieldDropdown";
const ADD_FORM_FIELD_CHECKBOX = "addFormFieldCheckbox";
const ADD_FORM_FIELD_RADIO_SET = "addFormFieldRadioSet";
const ALIGN_ELEMENT_TO_CANVAS_HORIZONTAL = "alignElementToCanvasHorizontal";
const ALIGN_ELEMENT_TO_CANVAS_VERTICAL = "alignElementToCanvasVertical";
const ALIGN_ELEMENT_TO_CANVAS_TOP = "alignElementToCanvasTop";
const ALIGN_ELEMENT_TO_CANVAS_BOTTOM = "alignElementToCanvasBottom";
const ALIGN_ELEMENT_TO_CANVAS_LEFT = "alignElementToCanvasLeft";
const ALIGN_ELEMENT_TO_CANVAS_RIGHT = "alignElementToCanvasRight";
const ALIGN_SELECTED_ELEMENTS_HORIZONTAL = "alignElementToSelectionHorizontal";
const ALIGN_SELECTED_ELEMENTS_VERTICAL = "alignElementToSelectionVertical";
const ALIGN_SELECTED_ELEMENTS_TOP = "alignElementToSelectionTop";
const ALIGN_SELECTED_ELEMENTS_BOTTOM = "alignElementToSelectionBottom";
const ALIGN_SELECTED_ELEMENTS_LEFT = "alignElementToSelectionLeft";
const ALIGN_SELECTED_ELEMENTS_RIGHT = "alignElementToSelectionRight";
const DISTRIBUTE_ELEMENTS_HORIZONTAL = "distributeElementsHorizontal";
const DISTRIBUTE_ELEMENTS_VERTICAL = "distributeElementsVertical";
const BRING_TO_FRONT = "bringToFront";
const BRING_FORWARD = "bringForward";
const SEND_BACKWARD = "sendBackward";
const SEND_TO_BACK = "sendToBack";
const SWAP_IMAGE = "swapImage";
const RESET_IMAGE = "resetImage";
const CROP_IMAGE = "cropImage";
const GROUP_ELEMENTS = "groupElements";
const UNGROUP_ELEMENTS = "ungroupElements";
const ADD_TO_GROUP = "addToGroup";
const REMOVE_FROM_GROUP = "removeFromGroup";
const INSPECT_ELEMENT_JSON = "inspectElementJson";

export {
  UNDO,
  REDO,
  COPY,
  CUT,
  SELECT_CANVAS,
  SELECT_SITE_CANVAS,
  DELETE_CANVAS,
  RENAME_CANVAS,
  LAYOUT_MOBILE_CANVAS,
  DUPLICATE_CANVAS,
  PASTE_ELEMENT,
  DELETE_ELEMENT,
  DUPLICATE_ELEMENT,
  RENAME_ELEMENT,
  TOGGLE_LOCK_ELEMENT,
  ADD_TEXT_ELEMENT_TITLE,
  ADD_TEXT_ELEMENT_HEADING,
  ADD_TEXT_ELEMENT_SUBHEADING,
  ADD_TEXT_ELEMENT_PARAGRAPH,
  ADD_ELEMENT_SIMPLE,
  ADD_ELEMENT_OVAL,
  ADD_ELEMENT_LINE,
  ADD_ELEMENT_GRAPHIC,
  ADD_ELEMENT_ICON,
  ADD_ELEMENT_IFRAME,
  ADD_ELEMENT_VIDEO,
  ADD_ELEMENT_GALLERY,
  ADD_ELEMENT_SOCIAL_GRID,
  ADD_ELEMENT_LOTTIE,
  ADD_ELEMENT_BUTTON,
  ADD_FORM_SUBMIT_BUTTON,
  ADD_FORM_FIELD_TEXT,
  ADD_FORM_FIELD_EMAIL,
  ADD_FORM_FIELD_PHONE,
  ADD_FORM_FIELD_DATE,
  ADD_FORM_FIELD_MULTI_LINE_TEXT,
  ADD_FORM_FIELD_DROPDOWN,
  ADD_FORM_FIELD_CHECKBOX,
  ADD_FORM_FIELD_RADIO_SET,
  ALIGN_ELEMENT_TO_CANVAS_HORIZONTAL,
  ALIGN_ELEMENT_TO_CANVAS_VERTICAL,
  ALIGN_ELEMENT_TO_CANVAS_TOP,
  ALIGN_ELEMENT_TO_CANVAS_BOTTOM,
  ALIGN_ELEMENT_TO_CANVAS_LEFT,
  ALIGN_ELEMENT_TO_CANVAS_RIGHT,
  ALIGN_SELECTED_ELEMENTS_HORIZONTAL,
  ALIGN_SELECTED_ELEMENTS_VERTICAL,
  ALIGN_SELECTED_ELEMENTS_TOP,
  ALIGN_SELECTED_ELEMENTS_BOTTOM,
  ALIGN_SELECTED_ELEMENTS_LEFT,
  ALIGN_SELECTED_ELEMENTS_RIGHT,
  DISTRIBUTE_ELEMENTS_HORIZONTAL,
  DISTRIBUTE_ELEMENTS_VERTICAL,
  BRING_TO_FRONT,
  BRING_FORWARD,
  SEND_BACKWARD,
  SEND_TO_BACK,
  SWAP_IMAGE,
  RESET_IMAGE,
  CROP_IMAGE,
  GROUP_ELEMENTS,
  UNGROUP_ELEMENTS,
  ADD_TO_GROUP,
  REMOVE_FROM_GROUP,
  INSPECT_ELEMENT_JSON,
};
